import { Skeleton, Stack } from "@mui/material";

export const InitiatePaymentFormSkeleton = () => (
  <Stack gap={4}>
    <Stack>
      <Skeleton height={21} width={180} variant="text" />
      <Stack gap={2}>
        <Skeleton height={53} variant="rectangular" />
        <Skeleton height={53} variant="rectangular" />
        <Skeleton height={53} variant="rectangular" />
      </Stack>
    </Stack>
    <Stack>
      <Skeleton height={21} width={110} variant="text" />
      <Skeleton height={53} variant="rectangular" />
    </Stack>
    <Skeleton variant="rectangular" height={58} sx={{ marginTop: 2 }} />
  </Stack>
);
